import React, { useState, useEffect } from 'react'

const Notice = () => {
    const [data, setData] = useState([])
    const [upload, setUpload] = useState(false)
    const [message, setMessage] = useState('')
    const [state, setState] = useState({
        title:'', content:'', imageFile:null
    })  

    const fetchData = async () => {
        try {
            const ACTION_URL = `https://www.durgacollege.in/dashboard/backend/fetch_notice.php`;
            const res = await fetch(ACTION_URL, {method:'GET'})
            const data = await res.json()
            if (res.status === 200 && data) {
                setData(data)
            }
        } catch (error){
            console.log(error);
        }
    }

    useEffect(() => {
        fetchData()
        document.title = 'Notice | Durga College Admin panel'
    }, [])

    const submitEvent = async e => {
        e.preventDefault()    
        if (state.title) {
            try {
                setUpload(true)
                const formData = new FormData(e.target)
                formData.append('action', 'addNotice')
                const ACTION_URL = `https://www.durgacollege.in/dashboard/backend/action.php`;
                const params = {
                    method: 'POST',
                    body: formData
                }
                const res = await fetch(ACTION_URL, params)
                const data = await res.json()
                if (res.status === 200 && data.status) {
                    setMessage(<div className="mb-3 success-message">{data.message}</div>)
                    setState({title:'', content:'', imageFile:null})
                    fetchData()   
                } else {
                    setMessage(<div className="mb-3 error-message">{data.message}</div>)
                }
                setUpload(false)
            } catch (error) {
                setMessage(<div className="mb-3 error-message">{error.message}</div>)
                setUpload(false)
            }
        }
    }

    const deleteNotice = async id => {        
        try {
            const ACTION_URL = `https://www.durgacollege.in/dashboard/backend/delete_notice.php?id=${id}`;
            const res = await fetch(ACTION_URL, {method:'GET'})
            const json = await res.json()
            if (res.status === 200 && json) {
                const filterData = data.filter(item => {
                    return item.id !== id
                })                
                setData(filterData)     
            }
        } catch (error){
            console.log(error);
        }        
    }

    return (
        <div className="notice">
            <h3 className="mb-3"><i className="bi bi-pencil-square"></i> Notice & Announcement</h3>
            <div id="message">{message}</div>
            <form method="post" className="mb-3" onSubmit={submitEvent}>
                <div className="mb-3">
                    <label htmlFor="title" className="form-label">Title : *</label>
                    <input
                        type="text"
                        name="title"
                        className="form-control"
                        onChange={e => setState({...state, title:e.target.value})} 
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="content" className="form-label">Content : </label>
                    <textarea 
                        name="content"
                        className="form-control" 
                        placeholder="Leave a content here"
                        rowSpan="4"
                        onChange={e => setState({...state, content:e.target.value})}  
                        id="content"></textarea>
                </div>
                <div className="mb-3">
                    <label htmlFor="imageFile" className="form-label">Choose File : </label>
                    <input
                        type="file"
                        name="imageFile"
                        className="form-control"
                        accept=".pdf, image/*"
                        multiple
                        onChange={e => setState({...state, content:e.target.files[0]})} 
                    />
                </div> 
                <button type="submit" className="btn btn-primary">
                {
                    !upload ? 'Upload' : 'Uploading...'
                }
                </button>
            </form>
            <hr/>
            {
                data.map((elem, idx) => {
                    return (
                        <div className="content-box mb-3" key={idx}>
                            <h3>{elem.title}</h3>
                            <h6>Post Date: {elem.insdate}</h6>
                            <p>{elem.content}</p>
                            {
                                elem.filename ? <a href={`https://www.durgacollege.in/images/notice/${elem.filename}`} target="_blank" rel="noreferrer" alt={elem.title}> View File</a> : ''
                            }
                            <div>
                                <button 
                                    type="botton" 
                                    className="btn btn-danger btn-sm" 
                                    onClick={() => {
                                        if (window.confirm('Are you sure you want to delete this?')) {
                                            deleteNotice(elem.id)
                                        }
                                    }}>Delete</button>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default Notice
